import React, {useEffect, useRef, useState} from 'react';
import {NiceServiceDto, VerityType} from "../types/types";
import { getNiceRequest } from "../apis/user";
import {isMobile} from "react-device-detect";
import {Checkbox} from "./Checkbox";
import {Button} from "./Button";
import {nToast} from "../plugins/reactToast";
import {useCookies} from "react-cookie";
import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { Icon } from '../components/Icon';
import TERMS_TEXT from "../constants/terms";
import NewLineText from "../common/NewLineText";
import PERSONAL_TEXT from "../constants/personal";

interface VerificationFormProps {
  returnUrl: string;
  buttonText: string;
  verifyType: VerityType;
  userEmail?: string;
  className?:string;
  innerTxtColor?:string;
  innerTxtColor2?:string;
  buttonColor?:string
}


export const VerificationForm = ({returnUrl, buttonText, verifyType, userEmail, className, innerTxtColor, innerTxtColor2, buttonColor}: VerificationFormProps
) =>  {
  const [formData, setFormData] = useState<NiceServiceDto>()
  const [_isMobile, setMobile] = useState(false);
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const verificationFormRef = useRef<HTMLFormElement | null>(null);
  const [open, setOpen] = useState(false)
  const [cookies] = useCookies();
  const [isApp, setIsApp] = useState<boolean>(true);
  useEffect(() => {
    if (!!!cookies['request-client'] && navigator.userAgent.indexOf('!!!IN APP EVENT!!!') === -1) {
      setIsApp(false);
    } else {
      setIsApp(true);
    }
  }, []);
  const handleClick = () => {
    if (verifyType === VerityType.PASSWORD && (!userEmail || userEmail.length === 0)) {
      nToast('이메일을 입력해주세요.');
      return;
    }
    if (!checkboxChecked) {
      nToast('약관을 동의해주세요.');
      return;
    }

    getNiceRequest({
      returnUrl: _isMobile ? returnUrl : '/verification',
      verifyType: verifyType,
      userEmail: userEmail,
    })
        .then((r) => {
          if (r.data && r.data.payload) {
            setFormData(r.data.payload);
          } else {
            nToast('데이터가 없습니다.'); // 또는 에러 처리 방식에 따라 처리
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.message) {
            nToast(e.response.data.message);
          } else {
            nToast('에러가 발생했습니다. 고객센터에 문의해주세요.');
          }
        });
  };

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    setMobile(isMobile);
  }, [isMobile]);

  useEffect(() => {
    if (formData && verificationFormRef.current) {
      if (!_isMobile) {
        window.open("", "nice", "width=300, height=300, scrollbars=no, right=100, top=100");
      }
      verificationFormRef.current.submit(); // 폼 제출
    }
  }, [formData]);

  return (
      <>
        <Dialog
            open={open}
            onClose={handleClose}
            fullScreen
        >
          <DialogTitle style={{padding:'15px'}} className={`flex justify-between items-center border-b`}>
            <p className={`font-semibold text-18`}>개인정보 취급방침</p>
            <Icon.X onClick={handleClose} />
          </DialogTitle>
          <DialogContent style={{margin:'0 15px'}} className={`text-13 leading-6`}>
            <NewLineText text={PERSONAL_TEXT} />
          </DialogContent>
        </Dialog>
        <div className={`w-full flex flex-col gap-y-2 ${className}`}>
          <p className={`flex flex-col text-12`}>
            <div className={`flex mb-2 justify-between`}>
              <div className={`flex`}>
                <Checkbox checked={checkboxChecked} className={`mr-2`} onChange={() => setCheckboxChecked(!checkboxChecked)} />
                <span onClick={() => setCheckboxChecked(!checkboxChecked)} className={`underline cursor-pointer`}>개인정보 수집 및 이용</span>
                <span onClick={() => setCheckboxChecked(!checkboxChecked)} className={`cursor-pointer`}>&nbsp;동의&nbsp;</span>
                <span className={`${innerTxtColor}`}>(필수)</span>
              </div>
              <button
                  className={`underline ${innerTxtColor2}`}
                  onClick={() => {isApp ?
                      setOpen(true)
                      :
                      window.open('/personalpolicy', '_blank')
                  }}>
                약관 보기
              </button>
            </div>
            <ul className={`text-12 leading-5 ml-5`}>
              <li className={`flex gap-x-1`}><span>-</span> 본인명의 휴대폰일 경우에만 본인인증이 가능합니다.</li>
              <li className={`flex gap-x-1`}><span>-</span> 본인인증 진행 시 이름, 휴대폰번호, 생년월일, 성별이&nbsp;<br className={`md:hidden`}/>자동으로 저장됩니다.</li>
            </ul>
          </p>
          <Button
              className={`text-white py-2 mt-4
                  ${checkboxChecked
                  ? (verifyType == VerityType.PASSWORD && (userEmail == null || userEmail?.length == 0) ? 'bg-gray-300' : `${buttonColor}`)
                  : 'bg-gray-300'
              }`}
              type="button" onClick={handleClick} text={buttonText}
          />
          <form
              ref={verificationFormRef}
              name="verification_form"
              action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb"
              target={_isMobile ? undefined : "nice"}
          >
            <input type="hidden" name="m" value="service"/>
            <input type="hidden" name="token_version_id" value={formData?.tokenVersionId}/>
            <input type="hidden" name="enc_data" value={formData?.encData}/>
            <input type="hidden" name="integrity_value" value={formData?.integrityValue}/>
          </form>
        </div>
      </>
  );
};
